import { tokenPrefix } from '@hivewatch/dark'
import type { ColorScheme, SystemStyleObject } from '@hivewatch/dark'

export const inboxReadToggleStyles = (
  colorScheme: ColorScheme,
  disabled: boolean
) => {
  const prefix = tokenPrefix(colorScheme)

  return {
    _disabled: {
      bg: 'transparent',
      borderColor: 'transparent',
      cursor: 'not-allowed',
      opacity: 0.55,
      _hover: { bg: 'transparent', borderColor: 'transparent' },
    },
    _focusVisible: {
      outline: '2px solid',
      outlineColor: `${prefix}interactive.focus-ring`,
      outlineOffset: '2px',
    },
    _hover: disabled
      ? { bg: 'transparent', borderColor: 'transparent' }
      : {
          bg: `${prefix}interactive.icon-button-hover-bg`,
          borderColor: `${prefix}border.strong`,
        },
    bg: 'transparent',
    border: '1px solid',
    borderColor: 'transparent',
    borderRadius: 'full',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.55 : 1,
  } satisfies SystemStyleObject
}

export const inboxReadToggleIndicatorStyles = (colorScheme: ColorScheme) =>
  ({
    bg: `${tokenPrefix(colorScheme)}interactive.radio-on`,
    borderRadius: 'full',
    h: '12px',
    w: '12px',
  } satisfies SystemStyleObject)
